var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: { position: "relative", top: _vm.UiService.getTopOfView() } },
    [
      _c("div", { attrs: { id: "topBannerList" } }, [
        _vm.product == _vm.shop.products[0]
          ? _c(
              "div",
              { staticClass: "topBannerList--pic flex-center-center" },
              [
                _c("img", {
                  staticClass: "w-100 img-fit",
                  class: {
                    "initial-filter": _vm.shop.info.hideDegradeCategory,
                  },
                  attrs: {
                    src: _vm.UrlService.imagePath(
                      _vm.product.ShopId,
                      _vm.product.ims
                    ),
                    alt: _vm.product.dn,
                  },
                  on: {
                    error: function ($event) {
                      $event.target.src = "dist/assets/no-img.png"
                    },
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.product.ty == _vm.PRODUCT_TYPES.Menu
          ? _c(
              "div",
              {
                staticClass:
                  "topBannerList--pic flex-center-center pos-relative",
              },
              [
                _c("img", {
                  staticClass: "w-100 img-fit",
                  class: {
                    "initial-filter": _vm.shop.info.hideDegradeCategory,
                  },
                  attrs: {
                    src: _vm.UrlService.imagePath(
                      _vm.product.ShopId,
                      _vm.product.ims
                    ),
                    alt: _vm.product.dn,
                  },
                  on: {
                    error: function ($event) {
                      $event.target.src = "dist/assets/no-img.png"
                    },
                  },
                }),
                _vm._v(" "),
                (_vm.product.allergens && _vm.product.allergens.length) ||
                (_vm.product.consumables && _vm.product.consumables.length)
                  ? _c(
                      "div",
                      { staticClass: "pos-absolute bottom-0 mb-30" },
                      [_c("product-tags", { attrs: { product: _vm.product } })],
                      1
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "topItemChildList bg-grey3" }, [
          _c("div", { staticClass: "container" }, [
            (_vm.shop.closed &&
              _vm.product.ty == _vm.PRODUCT_TYPES.RootCategory) ||
            _vm.product.ty !== _vm.PRODUCT_TYPES.Menu
              ? _c(
                  "div",
                  {
                    staticClass:
                      "itemChildList--categTitle flex-between-center flex-wrap p-5 pt-50",
                  },
                  [
                    _c("div", { staticClass: "title-desc flex-start-center" }, [
                      _c(
                        "h1",
                        {
                          staticClass:
                            "title display-2 color-grey1 text-bold m-0",
                        },
                        [
                          _vm.shop.closed &&
                          _vm.product.ty == _vm.PRODUCT_TYPES.RootCategory
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.shop.info.closedDescription)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.product.ty !== _vm.PRODUCT_TYPES.Menu
                            ? _c("span", [_vm._v(_vm._s(_vm.product.dn))])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "priceDetails flex-between-center" },
                      [
                        _vm.product.Promo
                          ? _c("promo-list-view", { staticClass: "display-4" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.product.ty == _vm.PRODUCT_TYPES.Category
                          ? _c(
                              "div",
                              { staticClass: "price display-4 color-1" },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.ShopService.prix(_vm.product.dp)
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.product.dd && _vm.product.ty !== _vm.PRODUCT_TYPES.Menu
              ? _c("div", { staticClass: "flex-between-center flex-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "description display-5 color-grey6 p-5" },
                    [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.truncate(_vm.product.dd)),
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  (_vm.product.allergens && _vm.product.allergens.length) ||
                  (_vm.product.consumables && _vm.product.consumables.length)
                    ? _c(
                        "div",
                        [
                          _c("product-tags", {
                            attrs: { product: _vm.product },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "container-fluid" }, [
          [_vm.PRODUCT_TYPES.Category, _vm.PRODUCT_TYPES.RootCategory].includes(
            _vm.product.ty
          )
            ? _c(
                "div",
                {
                  class: {
                    categoryBloc: !_vm.shop.info.display.itemChildList,
                    "categoryBlocList bg-grey3":
                      _vm.shop.info.display.itemChildList,
                  },
                },
                [
                  _c("div", { staticClass: "container" }, [
                    _c("div", [
                      _c("div", { staticClass: "productBloc" }, [
                        _c(
                          "ul",
                          { staticClass: "row" },
                          _vm._l(_vm.availableChilds, function (child, i) {
                            return _c("item-child-list", {
                              key: i,
                              attrs: {
                                item: child,
                                cart: _vm.cart,
                                shop: _vm.shop,
                              },
                            })
                          }),
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.product.ty == _vm.PRODUCT_TYPES.Product &&
          _vm.product.options.length
            ? _c(
                "div",
                { staticStyle: { "margin-top": "30px" } },
                [
                  _c("product-options", {
                    attrs: { "cart-item": _vm.cartItem },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.product.ty == _vm.PRODUCT_TYPES.Menu
            ? _c(
                "div",
                { staticClass: "menuCateg bg-grey3" },
                [
                  _c("menu-categories", {
                    attrs: { "cart-item": _vm.cartItem },
                    on: {
                      "add-to-cart": function ($event) {
                        return _vm.addToCart(_vm.cartItem)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }